import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const SpaSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$spaSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$spaSection' });

  return (
    <section id="hp-spa" className="hp-section spa-section spa">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('bed')} className="clearfix">
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homepage/spaSection/LEM-Spa-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homepage/spaSection/LEM-Spa-mob.jpg"
              />
              <img
                data-src="/images/homepage/spaSection/LEM-Spa.jpg"
                alt={t('alt')}
                src="/images/homepage/spaSection/LEM-Spa.jpg"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="960"
                height="700"
              />
            </picture>
          </div>
          <div className="stack right lem-bar">
            <h2>
              {t('title')}
              <span>{t('titleSpan')}</span>
            </h2>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-main">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default SpaSection;
